export default {
  props: ['info']
};
